import apiService from '@/api/apiService';
import { handleHttpError } from '@/api/errorHandler';

export const getDashboardStats = async () => {
    try {
        return await apiService.GET('/api/admin/dashboard/stats');
    } catch (error) {
        throw handleHttpError(error, '/api/admin/dashboard/stats', 'GET');
    }
};
